(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["eltobert-atelier"]) return;
  try {
    
if (!customElements.get('eltobert-atelier')) {
 customElements.define('eltobert-atelier', class extends HTMLElement {
  connectedCallback() {
   if (this.ready) return;
   queueMicrotask(()=>{ if(this.isConnected && !this.ready) { this.ready=true; this.init(); } });
  }
  init() {
   const root=this;
   const text=JSON.parse(root.querySelector('[data-atelier-config]').textContent);
   const tr=(key,values={})=>String(text[key]).replace(/\{(\w+)\}/g,(match,key)=>String(values[key]??match));
   const esc=value=>String(value).replace(/[&<>"']/g,char=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[char]));
   const money=value=>new Intl.NumberFormat(document.documentElement.lang||'en',{style:'currency',currency:'EUR',minimumFractionDigits:0,maximumFractionDigits:2}).format(value);
const defaults={1:[100],2:[70,30],3:[60,30,10],4:[50,25,15,10]};
 const palette=[["0", "#202022"], ["1", "#eee6d7"], ["2", "#b69350"], ["3", "#82523a"], ["4", "#ffffff"], ["5", "#a7adb2"], ["6", "#88927d"], ["7", "#205b48"], ["8", "#233850"], ["9", "#34758d"], ["10", "#702c40"], ["11", "#ad6951"], ["12", "#d6aaa3"], ["13", "#9c8978"]].map(([key,hex])=>[text['colour_'+key],hex]);
 let veinStrength=55;
 let count=3,shares=[...defaults[3]],colours=['#202022','#eee6d7','#b69350','#82523a'],wall=text.warm_ivory,size=80,amount=Number(root.dataset.price80);
 const el=id=>root.querySelector(`[id="${id}"]`), ns='http://www.w3.org/2000/svg';
 function redistribute(values,index,value){
  if(values.length===1)return [100];
  value=Math.max(0,Math.min(100,Math.round(value)));
  const others=values.map((v,i)=>({v,i})).filter(o=>o.i!==index),sum=others.reduce((s,o)=>s+o.v,0),remaining=100-value;
  const portions=others.map(o=>{const exact=remaining*(sum?o.v/sum:1/others.length);return {i:o.i,n:Math.floor(exact),fraction:exact-Math.floor(exact)}});
  let extra=remaining-portions.reduce((s,o)=>s+o.n,0);
  portions.sort((a,b)=>b.fraction-a.fraction||a.i-b.i).forEach(o=>{if(extra>0){o.n++;extra--}});
  const next=values.slice();next[index]=value;portions.forEach(o=>next[o.i]=o.n);return next;
 }
 function name(hex){return palette.find(p=>p[1]===hex)?.[0]||hex.toUpperCase()}
 function renderControls(){
  el('colourControls').innerHTML=shares.map((v,i)=>`<div class="colourRow"><input type="color" id="colour${i}" aria-label="${esc(tr('colour',{n:i+1}))}" value="${colours[i]}"><label for="preset${i}">${esc(tr('colour',{n:i+1}))}<select id="preset${i}" aria-label="${esc(tr('palette',{n:i+1}))}">${palette.map(p=>`<option value="${p[1]}" ${p[1]===colours[i]?'selected':''}>${esc(p[0])}</option>`).join('')}<option value="custom" ${!palette.some(p=>p[1]===colours[i])?'selected':''}>${esc(text.custom)}</option></select></label><span class="pct"><input id="percent${i}" type="number" min="0" max="100" step="1" aria-label="${esc(tr('percentage',{n:i+1}))}" value="${v}" ${count===1?'disabled':''}> %</span><input type="range" id="range${i}" min="0" max="100" step="1" aria-label="${esc(tr('proportion',{n:i+1}))}" value="${v}" ${count===1?'disabled':''}></div>`).join('');
  shares.forEach((_,i)=>{
   el('colour'+i).addEventListener('input',e=>{colours[i]=e.target.value;el('preset'+i).value=palette.some(p=>p[1]===colours[i])?colours[i]:'custom';update()});
   el('preset'+i).addEventListener('change',e=>{if(e.target.value==='custom'){el('colour'+i).click();return}colours[i]=e.target.value;el('colour'+i).value=colours[i];update()});
   ['percent','range'].forEach(prefix=>el(prefix+i).addEventListener('input',e=>{if(e.target.value===''){return}const v=Number(e.target.value);if(!Number.isFinite(v))return;shares=redistribute(shares,i,v);update()}));
   el('percent'+i).addEventListener('blur',update);
  });update();
 }
 function update(){
  shares.forEach((v,i)=>{el('range'+i).value=v;el('percent'+i).value=v;el('range'+i).setAttribute('aria-valuetext',tr('percent',{value:v}))});
  el('balanceBar').innerHTML=shares.map((v,i)=>`<span style="width:${v}%;background:${colours[i]}"></span>`).join('');
  el('total').textContent=tr('total',{value:shares.reduce((a,b)=>a+b,0)});
  const active=shares.map((v,i)=>({v,colour:colours[i]})).filter(p=>p.v>0);
  el('veinDetail').disabled=active.length<2;
  el('veinValue').textContent=active.length<2?text.one_colour:veinStrength===0?text.soft:veinStrength<35?text.subtle:veinStrength<76?text.balanced:text.expressive;
  const gradient=el('resinBlend');gradient.replaceChildren();
  function svg(tag,attrs,parent){const node=document.createElementNS(ns,tag);Object.entries(attrs).forEach(([k,v])=>node.setAttribute(k,v));parent.append(node);return node}
  let cumulative=0;
  active.forEach((p,i)=>{
   const start=cumulative;cumulative+=p.v;
   const soft=Math.min(4.5,p.v*.22);
   svg('stop',{offset:(i===0?0:start+soft)+'%','stop-color':p.colour},gradient);
   svg('stop',{offset:(i===active.length-1?100:cumulative-soft)+'%','stop-color':p.colour},gradient);
  });
  const group=el('colourFlow');group.replaceChildren();
  svg('rect',{x:-60,y:-60,width:420,height:420,fill:active[0].colour},group);
  if(active.length>1){
   svg('rect',{x:-45,y:-45,width:390,height:390,fill:'url(#resinBlend)',filter:'url(#resinWarp)'},group);
   let boundary=0;
   active.slice(0,-1).forEach((p,i)=>{
    boundary+=p.v;const y=boundary*3;
    for(let j=0;j<3;j++){
     const delta=(j-1)*5;
     svg('path',{d:`M-65 ${y-70+delta} C35 ${y-120+delta} 80 ${y+65+delta} 170 ${y+delta} S300 ${y+65+delta} 375 ${y+100+delta}`,fill:'none',stroke:active[i+1].colour,'stroke-width':j===1?2.6:1,'stroke-opacity':j===1?.55:.35,filter:'url(#resinWarp)'},group);
    }
   });
  }
  if(active.length>1 && veinStrength>0){
   const strength=veinStrength/100;
   // Seeded irregular curves keep the composition stable while sliders move.
   const noise=(n)=>{const v=Math.sin(n*127.1+31.7)*43758.5453;return v-Math.floor(v)};
   const clusters=[{x:12,y:82,angle:-.32,length:170},{x:168,y:222,angle:.43,length:145},{x:40,y:270,angle:-.76,length:112}];
   clusters.slice(0,veinStrength>75?3:2).forEach((c,k)=>{
    const colour=active[(k+1)%active.length].colour;
    const local=svg('g',{transform:`translate(${c.x} ${c.y}) rotate(${c.angle*180/Math.PI})`,filter:'url(#veinWarp)'},group);
    const segments=9, points=Array.from({length:segments+1},(_,j)=>({x:j*c.length/segments,y:Math.sin(j*.73+k)*9+(noise(j+k*21)-.5)*10}));
    const d='M'+points.map(p=>`${p.x.toFixed(2)} ${p.y.toFixed(2)}`).join(' L');
    svg('path',{d,fill:'none',stroke:colour,'stroke-width':2.4+strength*2,'stroke-opacity':.08+strength*.07,'stroke-linejoin':'round'},local);
    svg('path',{d,fill:'none',stroke:colour,'stroke-width':.45+strength*.7,'stroke-opacity':.32+strength*.38,'stroke-linejoin':'round','stroke-linecap':'round'},local);
    const branches=Math.round(2+strength*5);
    for(let j=0;j<branches;j++){
     const p=points[1+j],sign=j%2?1:-1,l=12+noise(j+k*12)*28;
     const branch=`M${p.x} ${p.y} l${l*.22} ${sign*l*.35} l${l*.3} ${sign*l*.12} l${l*.12} ${sign*l*.43}`;
     svg('path',{d:branch,fill:'none',stroke:colour,'stroke-width':.3+strength*.4,'stroke-opacity':.2+strength*.32,'stroke-linecap':'round'},local);
    }
   });
  }
  svg('rect',{x:0,y:0,width:300,height:300,fill:'url(#resinSheen)'},group);
  el('colourClock').setAttribute('aria-label',tr('visual_label',{colours:shares.map((v,i)=>name(colours[i])+' '+v+'%').join(', ')}));
  el('depositNote').textContent=tr('deposit',{amount:money(amount*.4)});
  const summary=tr('summary',{size,wall,colours:shares.map((v,i)=>name(colours[i])+' ('+colours[i]+') — '+v+'%').join(', '),price:money(amount),deposit:money(amount*.4)});
  el('directionLink').href='https://wa.me/35679985969?text='+encodeURIComponent(summary);
 }
 root.querySelectorAll('.countBtn').forEach(b=>b.addEventListener('click',()=>{count=Number(b.dataset.count);shares=[...defaults[count]];root.querySelectorAll('.countBtn').forEach(x=>x.setAttribute('aria-pressed',String(x===b)));renderControls()}));
 el('veinDetail').addEventListener('input',e=>{veinStrength=Number(e.target.value);update()});
 el('resetSplit').addEventListener('click',()=>{shares=[...defaults[count]];update()});
 root.querySelectorAll('.swatch').forEach(b=>b.addEventListener('click',()=>{root.querySelectorAll('.swatch').forEach(x=>x.setAttribute('aria-pressed',String(x===b)));wall=b.getAttribute('aria-label');el('wallName').textContent=wall;el('room').style.backgroundColor=b.dataset.color;update()}));
 root.querySelectorAll('.sizeBtn').forEach(b=>{b.setAttribute('aria-pressed',String(b.classList.contains('active')));b.addEventListener('click',()=>{root.querySelectorAll('.sizeBtn').forEach(x=>{x.classList.toggle('active',x===b);x.setAttribute('aria-pressed',String(x===b))});size=Number(b.dataset.cm);amount=Number(b.dataset.amount);el('clockStage').style.width=b.dataset.size+'px';el('price').textContent=money(amount);update()})});
 for(let i=0;i<12;i++){const line=document.createElementNS(ns,'line');line.setAttribute('x1','150');line.setAttribute('y1','18');line.setAttribute('x2','150');line.setAttribute('y2','29');line.setAttribute('transform',`rotate(${i*30} 150 150)`);el('dial').append(line)}
 el('price').textContent=money(amount);
 renderControls();
 root.querySelectorAll('.reveal').forEach(x=>x.classList.add('in'));
  }
 });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eltobert-studio-discovery"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialise = (root) => {
      if (!root || root.dataset.ebStudioDiscoveryReady === 'true') return;
      root.dataset.ebStudioDiscoveryReady = 'true';

      const tabs = Array.from(root.querySelectorAll('[data-eb-sd-tab]'));
      const panels = Array.from(root.querySelectorAll('[data-eb-sd-panel]'));

      const activePanel = () => panels.find((panel) => !panel.hidden);

      const activate = (tab, moveFocus = false) => {
        const target = tab.dataset.ebSdTab;
        tabs.forEach((item) => {
          const selected = item === tab;
          item.classList.toggle('is-active', selected);
          item.setAttribute('aria-selected', selected ? 'true' : 'false');
          item.tabIndex = selected ? 0 : -1;
        });
        panels.forEach((panel) => {
          const selected = panel.dataset.ebSdPanel === target;
          panel.hidden = !selected;
          panel.classList.toggle('is-active', selected);
        });
        tab.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        if (moveFocus) tab.focus();
      };

      tabs.forEach((tab, index) => {
        tab.tabIndex = tab.classList.contains('is-active') ? 0 : -1;
        tab.addEventListener('click', () => activate(tab));
        tab.addEventListener('keydown', (event) => {
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          event.preventDefault();
          const direction = event.key === 'ArrowRight' ? 1 : -1;
          const nextIndex = (index + direction + tabs.length) % tabs.length;
          activate(tabs[nextIndex], true);
        });
      });

      const scrollActiveRail = (direction) => {
        const rail = activePanel()?.querySelector('[data-eb-sd-rail]');
        const card = rail?.querySelector('[data-eb-sd-product]');
        if (!rail || !card) return;
        const gap = parseFloat(getComputedStyle(rail).columnGap || getComputedStyle(rail).gap || 0);
        rail.scrollBy({ left: direction * (card.getBoundingClientRect().width + gap), behavior: 'smooth' });
      };

      root.querySelector('[data-eb-sd-prev]')?.addEventListener('click', () => scrollActiveRail(-1));
      root.querySelector('[data-eb-sd-next]')?.addEventListener('click', () => scrollActiveRail(1));

      panels.forEach((panel) => {
        const rail = panel.querySelector('[data-eb-sd-rail]');
        const dots = panel.querySelector('[data-eb-sd-dots]');
        const cards = Array.from(panel.querySelectorAll('[data-eb-sd-product]'));
        if (!rail || !dots || cards.length < 2) return;

        cards.forEach((card, index) => {
          const dot = document.createElement('span');
          dot.className = `eb-sd__dot${index === 0 ? ' is-active' : ''}`;
          dots.appendChild(dot);
        });

        let ticking = false;
        rail.addEventListener('scroll', () => {
          if (ticking) return;
          ticking = true;
          requestAnimationFrame(() => {
            const firstCard = cards[0];
            const gap = parseFloat(getComputedStyle(rail).columnGap || getComputedStyle(rail).gap || 0);
            const step = firstCard.getBoundingClientRect().width + gap;
            const activeIndex = step > 0 ? Math.round(rail.scrollLeft / step) : 0;
            Array.from(dots.children).forEach((dot, index) => dot.classList.toggle('is-active', index === activeIndex));
            ticking = false;
          });
        }, { passive: true });
      });
    };

    const initialiseAll = (scope = document) => {
      scope.querySelectorAll('[data-eb-studio-discovery]').forEach(initialise);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initialiseAll());
    } else {
      initialiseAll();
    }

    document.addEventListener('shopify:section:load', (event) => initialiseAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  function initialiseHeroSlider(slider) {
    if (!slider || slider.dataset.sliderInitialised === 'true') return;

    const slides = Array.from(slider.querySelectorAll('[data-hero-slide]'));

    if (slides.length === 0) return;

    slider.dataset.sliderInitialised = 'true';

    const previousButton = slider.querySelector('[data-hero-slider-previous]');
    const nextButton = slider.querySelector('[data-hero-slider-next]');
    const dotsContainer = slider.querySelector('[data-hero-slider-dots]');

    const autoplayEnabled = slider.dataset.autoplay === 'true';
    const pauseOnHover = slider.dataset.pauseOnHover === 'true';
    const speed = Number(slider.dataset.speed) || 5000;

    let currentSlide = 0;
    let autoplayTimer = null;
    let touchStartX = 0;
    let touchEndX = 0;

    slides.forEach((slide) => {
      slide.classList.remove('is-active', 'is-previous');
      slide.setAttribute('aria-hidden', 'true');
    });

    slides[0].classList.add('is-active');
    slides[0].setAttribute('aria-hidden', 'false');

    function createDots() {
      if (!dotsContainer) return;

      dotsContainer.innerHTML = '';

      slides.forEach((slide, index) => {
        const dot = document.createElement('button');

        dot.type = 'button';
        dot.className = 'hero-slider__dot';
        dot.setAttribute('aria-label', `Go to slide ${index + 1}`);

        if (index === 0) {
          dot.classList.add('is-active');
          dot.setAttribute('aria-current', 'true');
        }

        dot.addEventListener('click', () => {
          showSlide(index);
          restartAutoplay();
        });

        dotsContainer.appendChild(dot);
      });
    }

    function updateDots() {
      if (!dotsContainer) return;

      const dots = dotsContainer.querySelectorAll('.hero-slider__dot');

      dots.forEach((dot, index) => {
        const active = index === currentSlide;

        dot.classList.toggle('is-active', active);

        if (active) {
          dot.setAttribute('aria-current', 'true');
        } else {
          dot.removeAttribute('aria-current');
        }
      });
    }

    function showSlide(newIndex) {
      if (slides.length <= 1) return;

      const oldIndex = currentSlide;

      if (newIndex < 0) {
        newIndex = slides.length - 1;
      }

      if (newIndex >= slides.length) {
        newIndex = 0;
      }

      slides.forEach((slide) => {
        slide.classList.remove('is-active', 'is-previous');
        slide.setAttribute('aria-hidden', 'true');
      });

      slides[oldIndex].classList.add('is-previous');
      slides[newIndex].classList.add('is-active');
      slides[newIndex].setAttribute('aria-hidden', 'false');

      currentSlide = newIndex;
      updateDots();
    }

    function nextSlide() {
      showSlide(currentSlide + 1);
    }

    function previousSlide() {
      showSlide(currentSlide - 1);
    }

    function stopAutoplay() {
      if (autoplayTimer) {
        window.clearInterval(autoplayTimer);
        autoplayTimer = null;
      }
    }

    function startAutoplay() {
      if (!autoplayEnabled || slides.length <= 1) return;

      stopAutoplay();
      autoplayTimer = window.setInterval(nextSlide, speed);
    }

    function restartAutoplay() {
      stopAutoplay();
      startAutoplay();
    }

    if (previousButton) {
      previousButton.addEventListener('click', () => {
        previousSlide();
        restartAutoplay();
      });
    }

    if (nextButton) {
      nextButton.addEventListener('click', () => {
        nextSlide();
        restartAutoplay();
      });
    }

    if (pauseOnHover) {
      slider.addEventListener('mouseenter', stopAutoplay);
      slider.addEventListener('mouseleave', startAutoplay);
    }

    let touchStartY = 0;
let touchCurrentX = 0;
let touchCurrentY = 0;

slider.addEventListener(
  'touchstart',
  (event) => {
    const touch = event.touches[0];

    touchStartX = touch.clientX;
    touchStartY = touch.clientY;
    touchCurrentX = touchStartX;
    touchCurrentY = touchStartY;

    stopAutoplay();
  },
  { passive: true }
);

slider.addEventListener(
  'touchmove',
  (event) => {
    const touch = event.touches[0];

    touchCurrentX = touch.clientX;
    touchCurrentY = touch.clientY;
  },
  { passive: true }
);

slider.addEventListener(
  'touchend',
  () => {
    const horizontalDistance = touchCurrentX - touchStartX;
    const verticalDistance = touchCurrentY - touchStartY;

    const isHorizontalSwipe =
      Math.abs(horizontalDistance) >= 50 &&
      Math.abs(horizontalDistance) > Math.abs(verticalDistance);

    if (isHorizontalSwipe) {
      if (horizontalDistance < 0) {
        nextSlide();
      } else {
        previousSlide();
      }
    }

    restartAutoplay();
  },
  { passive: true }
);

    createDots();
    startAutoplay();
  }

  function initialiseAllHeroSliders(container = document) {
    container.querySelectorAll('[data-hero-slider]').forEach(initialiseHeroSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initialiseAllHeroSliders();
    });
  } else {
    initialiseAllHeroSliders();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initialiseAllHeroSliders(event.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
